import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Bahncard } from '../../model/bahncard';
import { ErpTravelManagementCommonService } from '../../../shared/service/travelmanagementcommon.service';
import { AutoComplete } from 'primeng/autocomplete';
import { ErpBahncardValue } from '../../../shared/model/travelmanagement-values';
@Component( {
    selector: 'erp-businesstripapplication-bahncard',
    templateUrl: './businesstripapplication-bahncard.component.html'
} )
export class BusinesstripApplicationBahncardComponent implements OnInit, OnChanges {
    @Input() pgdJoinId?: number;
    @ViewChild( 'selectedBahncardDropdown', { static: true } ) selectedBahncardDropdown: AutoComplete | undefined;
    public bahncard: Bahncard = new Bahncard();
    public tempBahncardSelected?: ErpBahncardValue;

    constructor( private readonly erpTravelManagementCommonService: ErpTravelManagementCommonService ) {
    }

    ngOnInit(): void { }

    ngOnChanges( changes: SimpleChanges ): void {
        if ( this.pgdJoinId !== undefined ) {
            this.getBahncardsByPgdJoinIdAndUpdateSelectedBahncardDropdown( this.pgdJoinId );
        }
    }

    private updateSelectedBahncardDropdownTextToChangeText(): void {
        // Showing changeText instead selectedBahncard if value is available (sva compatibility)
        if ( this.bahncard.changeText !== undefined && this.selectedBahncardDropdown !== undefined ) {
            this.selectedBahncardDropdown.inputFieldValue = this.bahncard.changeText;
        }
    }

    private getBahncardsByPgdJoinIdAndUpdateSelectedBahncardDropdown( pgdJoinId: number ): void {
        this.erpTravelManagementCommonService.getBahncardsByPgdJoinId( pgdJoinId ).subscribe( {
            next: ( newBahncard ) => {
                this.bahncard = newBahncard;
                this.updateSelectedBahncardDropdownTextToChangeText();
            },
            error: () => {
                // Fehler behandeln, Änderungen konnten nicht gespeichert werden.
            }
        } );
    }

    public bahncardSelected(): void {
        // Set changeText to selectedBahncardText (sva compatibility)
        this.bahncard.changeText = this.tempBahncardSelected?.text;
    }

    public resetBahncardChanges(): void {
        if ( this.bahncard.changeBahncard === false ) {
            if ( this.selectedBahncardDropdown !== undefined ) {
                this.tempBahncardSelected = undefined;
                this.selectedBahncardDropdown.updateInputField();
            }
            this.bahncard.changeText = undefined;
            this.bahncard.changeFromDate = undefined;
            this.bahncard.changeToDate = undefined;
        }
    }

    public saveBahncardChanges(): void {
        this.erpTravelManagementCommonService.saveBahncardChanges( this.bahncard ).subscribe( {
            next: ( newBahncard ) => {
                this.bahncard = newBahncard;
            },
            error: () => {
                // Fehler behandeln, Änderungen konnten nicht gespeichert werden.
            }
        } );
    }
}
